<template>
    <div>
        <!--新增FaceUnlock弹框-->
        <el-dialog :title="$t('AddFaceUnlock')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="addFace.addFaceFrom" 
            center 
            :show-close="addFace.showClose" 
        >
            <div class="addsiteUersBox">
                <div class="addSiteUserLeft">
                    <el-form>
                        <el-form-item :label="$t('Name') + ' *'">
                            <el-input style="width: 96%;" v-model="addFace.title"></el-input>
                        </el-form-item>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockFace')">
                                    <el-button style="margin-top: 10px;width: 100%;" @click="showFaceRecordBox" type="primary">{{$t('ClickToCapture')}}</el-button>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockOption') + ' *'">
                                    <el-select v-model="addFace.locks" multiple :placeholder="$t('PleaseSelect')">
                                        <el-option
                                        v-for="item in addFace.locksOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top:20px;padding-top:20px;">
                            <div class="LimitBox">
                                <div style="width:48%;">
                                    <el-form-item :label="$t('Limited')" label-width="100px">
                                        <el-input v-model="addFace.countLimit" :disabled="addFace.countLimitDis"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('NumbeOfUses')}}</span>
                                </div>
                            </div>
                            <div class="LimitBox">
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('Unlinmited')}}</span>
                                </div>
                                <div class="cardText">
                                    <el-switch
                                    @change="addFaceUnlinmitChage"
                                    v-model="addFace.Unlinmited">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top: 10px;border-bottom: 1px solid #ddd; padding-top:20px;padding-bottom:30px;">
                            <div class="LimitBox">
                                <div>
                                    <el-form-item :label="$t('ValidityTime')" :title="$t('ValidityTime')" class="ValidityTimeLable" label-width="120px">
                                        <el-date-picker
                                        :disabled="addFace.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="addFace.startTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('StartTime')">
                                        </el-date-picker> ~ 
                                        <el-date-picker
                                        :disabled="addFace.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="addFace.endTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('EndTime')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="FoveverBox">
                                <div style="padding-right: 20px; margin-top: 20px;color: #333;">
                                    <el-form-item :label="$t('Forever')" :title="$t('Forever')" class="ValidityTimeLable" label-width="120px">
                                        <el-switch
                                            @change="addFaceForeverChage"
                                            v-model="addFace.fovever">
                                        </el-switch>
                                    </el-form-item>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </el-form>
                </div>
                <div class="addSiteUserRight">
                    <div>{{$t('PanelSync')}}</div>
                    <div class="licenseBox" style="height: 380px;">
                        <div v-for="item in addFace.devList" :key="item.id" style="margin-bottom: 5px">
                            <el-checkbox  v-model="item.isChecked">{{item.deviceName}}</el-checkbox>
                        </div>
                        
                    </div>
                    <!-- <el-button @click="showFaceRecordBox">{{$t('Add')}}</el-button> -->
                </div>
            </div>
            <div slot="footer" class="dialog-footer addCard">
                <el-button @click="addFace.addFaceFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" :loading="addFace.addBtnState === 1" class="selectBtn" style="margin-left: 60px !important" @click="addFaceUnlock">{{$t('Confirm')}}</el-button>
            </div>
             <!--Face record弹框(添加)-->
             <el-dialog
                :title="$t('FaceRecord')"
                :visible.sync="addFaceRecord.addFaceRecordFrom"
                :close-on-click-modal="false" 
                :close-on-press-escape="false"
                width="600px"
                append-to-body
                :show-close="addFaceRecord.showClose">
                <div style="display: flex;justify-content: center;" v-show="addFaceRecord.showUploadType === 1">
                    <video style="background: #000;width: 480px;height: 480px;" ref="videoElement" autoplay playsinline ></video>
                </div>
                <div style="display: flex;justify-content: center;" v-show="addFaceRecord.showUploadType === 2">
                    <!-- <img width="500" height="300" :src="addFaceRecord.previewImage" class="avatar"> -->
                    <canvas ref="showPhotoCanvas" width="480" height="480"></canvas>
                </div>
                <!-- <el-button @click="downloadCanvasWithQuality" type="primary">下载图片</el-button> -->
                <div class="faceRecordfootBox" v-show="addFaceRecord.faceRecordfootBoxShow === 1">
                    <img :src="addFaceRecord.camera" @click="takePhoto" alt="">
                    <el-upload
                          class="avatar-uploader"
                          accept=".jpg"
                          :before-upload="checkFileType"
                          :auto-upload='false'
                          action="#" 
                          :show-file-list="false"
                          :limit="1"
                          :multiple="false"
                          :on-change="handleFileChange"
                          :file-list="addFaceRecord.fileList"
                          >
                          <div class="addImg">
                              <img :src="addFaceRecord.album" class="avatar">
                          </div>
                      </el-upload>
                </div>
                <div class="faceRecordfootBox" v-show="addFaceRecord.faceRecordfootBoxShow === 2">
                    <div style="text-align:center;">
                        <img :src="addFaceRecord.faceDownload" class="avatar">
                        <div style="margin-top: 5px;">{{$t('ValidatingImage')}}</div>
                    </div>
                </div>
                <div class="faceRecordfootBox" v-show="addFaceRecord.faceRecordfootBoxShow === 3">
                    <div style="text-align:center;">
                        <img :src="addFaceRecord.faceSuccess" class="avatar">
                        <div style="margin-top: 5px;">{{$t('ImageValiditedSuccessfully')}}</div>
                        <div style="margin-top: 15px;">
                            <el-button type="primary" @click="photoValiditedSuccess" class="selectBtn">{{$t('Confirm')}}</el-button>
                        </div>
                    </div>
                </div>
                <div class="faceRecordfootBox" v-show="addFaceRecord.faceRecordfootBoxShow === 4">
                    <div style="text-align:center;">
                        <img :src="addFaceRecord.faceFailed" class="avatar">
                        <div style="margin-top: 5px;">{{$t('ImageValiditedFailed')}}</div>
                        <div style="margin-top: 15px;">
                            <el-button type="primary" @click="photoValiditedRetry" class="selectBtn">{{$t('Retry')}}</el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </el-dialog>
        <!--编辑Face弹框-->
        <el-dialog :title="$t('EditPasswordUnlock')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="editFace.editFaceFrom" 
            center 
            :show-close="editFace.showClose" 
        >
            <div class="addsiteUersBox">
                <div class="addSiteUserLeft">
                    <el-form>
                        <el-form-item :label="$t('Name')  + ' *'">
                            <el-input v-model="editFace.title"></el-input>
                        </el-form-item>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockFace')">
                                    <el-button style="margin-top: 10px;width: 100%;" type="primary" disabled>{{$t('ClickToCapture')}}</el-button>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item :label="$t('UnlockOption') + ' *'">
                                    <el-select v-model="editFace.locks" multiple :placeholder="$t('PleaseSelect')">
                                        <el-option
                                        v-for="item in editFace.locksOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                            </el-form-item>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top:20px;padding-top:20px;">
                            <div class="LimitBox">
                                <div style="width:48%;">
                                    <el-form-item :label="$t('Limited')" label-width="100px">
                                        <el-input v-model="editFace.countLimit" :disabled="editFace.countLimitDis"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('NumbeOfUses')}}</span>
                                </div>
                            </div>
                            <div class="LimitBox">
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('Unlinmited')}}</span>
                                </div>
                                <div class="cardText">
                                    <el-switch
                                    @change="editFaceUnlinmitChage"
                                    v-model="editFace.Unlinmited">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top: 10px;border-bottom: 1px solid #ddd; padding-top:20px;padding-bottom:30px;">
                            <div class="LimitBox">
                                <div>
                                    <el-form-item :label="$t('ValidityTime')" :title="$t('ValidityTime')" class="ValidityTimeLable" label-width="120px">
                                        <el-date-picker
                                        :disabled="editFace.isFovever"
                                        style="width: 46%; font-size:14px;"
                                        v-model="editFace.startTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('StartTime')">
                                        </el-date-picker> ~ 
                                        <el-date-picker
                                        :disabled="editFace.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="editFace.endTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('EndTime')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="FoveverBox">
                                <div style="padding-right: 20px; margin-top: 20px;color: #333;">
                                    <el-form-item :label="$t('Forever')" :title="$t('Forever')" class="ValidityTimeLable" label-width="120px">
                                        <el-switch
                                            @change="editFaceForeverChage"
                                            v-model="editFace.fovever">
                                        </el-switch>
                                    </el-form-item>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </el-form>
                </div>
                <div class="addSiteUserRight">
                    <div>{{$t('PanelSync')}}</div>
                    <div class="licenseBox" style="height: 380px;">
                        <div v-for="item in editFace.devList" :key="item.id" style="margin-bottom: 5px;display:flex;justify-content: space-between;">
                            <el-checkbox  v-model="item.isChecked">{{item.deviceName}}</el-checkbox>
                            <div v-show="item.isChecked" style="color:#999;font-size:14px;">{{handPanelApplyStatus(item.applyStatus)}}</div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer addCard">
                <el-button @click="editFace.editFaceFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" :loading="editFace.editBtnState === 1" class="selectBtn" style="margin-left: 60px !important" @click="editFaceUnlock">{{$t('Confirm')}}</el-button>
            </div>
        </el-dialog>
        <!--删除Password弹框-->
        <el-dialog
            :title="$t('Delete')"
            :visible.sync="delFace.delFaceFrom"
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            width="500px"
            :show-close="delFace.showClose">
            <p class="deleteDesc">{{$t('ConfirmDeleteFaceUnlockSetting')}}</p>
            <span slot="footer" class="dialog-footer addCard">
                <el-button @click="delFace.delFaceFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" class="selectBtn" style="margin-left: 60px !important" :loading="delFace.delBtnState === 1" @click="delFaceSetting">{{$t('Confirm')}}</el-button>
            </span>
        </el-dialog>
        <div class="noSipsettings" v-show="face.hasNoFace">{{$t('NoData')}}!</div>
        <template>
            <el-table
            v-show="!face.hasNoFace"
            :data="face.faceList"
            style="width: 100%;"
            :header-cell-style="{background:'#EDEFFB',color:'#4D4D4F'}"
            >
                <el-table-column
                    label="#"
                    type="index"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="title"
                    :label="$t('Name')"
                    >
                </el-table-column>
                <el-table-column
                    prop="locks"
                    :label="$t('LockTemplate')"
                    >
                </el-table-column>
                
                <!-- <el-table-column
                    prop="payload"
                    :label="$t('PassWord')"
                    >
                    <template slot-scope="scope">
                        {{decryptFaceUnlock(scope.row.payload)}}
                    </template>
                </el-table-column> -->
                <el-table-column
                    prop="countLimit"
                    :label="$t('LimitedUse')"
                    >
                    <template slot-scope="scope">
                        {{handCountLimit(scope.row.countLimit,scope.row.usedCount)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="startTime"
                    :label="$t('ValidityTime')"
                    >
                    <template slot-scope="scope">
                        {{validityTime(scope.row.startTime,scope.row.endTime)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="entranceDeviceIds"
                    :label="$t('PanelSync')"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        {{showPanelsName(scope.row.entranceDeviceIds)}}
                    </template>
                </el-table-column>
                <el-table-column width="150"  label="..." align="center">
                    <template slot-scope="scope">
                        <el-image :src="face.editImg" :title="$t('Edit')"  @click="editFaceSetting(scope.row)" style="width:24px;" fit="fill"></el-image>
                        <el-image :src="face.deleteImg" :title="$t('Delete')"  @click="openDelFaceFrom(scope.row)" style="width:24px;margin-left:1vw" fit="fill"></el-image>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
  
</template>

<script>
import CryptoJS from 'crypto-js';
import { encryptCBC, decryptCBC,encryptCBCFile } from "@/util/aes";
import SparkMD5 from 'spark-md5'
import SnowflakeId from 'snowflake-id'
import { mapState } from 'vuex';
import sitesUsersApi from '@/api/siteusers/index.js'
import editImg from '@/assets/images/edit.png'
import deleteImg from '@/assets/images/delete.png'
import camera from '@/assets/images/camera.png'
import album from '@/assets/images/album.png'
import faceDownload from '@/assets/images/test_driver_loading.gif'
import faceSuccess from '@/assets/images/success.png'
import faceFailed from '@/assets/images/face_failed.png'
export default {
    name:"FaceUnlock",
    data(){
        return{
            updateSiteUser:{
                id:"",
                userId:"",
            },
            face:{
                hasNoFace:false,
                faceList:[],
                editImg,
                deleteImg,
            },
            addFace:{
                addFaceFrom:false,
                showClose:true,
                title:"",
                // addCardType:"",
                payload:"",
                file:null,
                fileMD5Str:'',
                locks:"",
                locksOptions:[
                    {
                        id:"1",
                        name:"Lock 1"
                    },
                    {
                        id:"2",
                        name:"Lock 2"
                    },
                ],
                countLimitDis:false,
                countLimit:"",
                Unlinmited:false,
                devList:[],
                startTime:"",
                endTime:"",
                isFovever:false,
                fovever:false,
                addBtnState:0,
                encryptedBlob:null,
            },
            addFaceRecord:{
                addFaceRecordFrom:false,
                showClose:true,
                showUploadType:1, //1:摄像头 2:图片上传
                faceRecordfootBoxShow:1, //1.初始状态，显示照相和上传图片图标 2:图片检测状态 3:图片检测成功 4:图片检测失败
                isUploadPhoto:1, //1:摄像头 2:图片上传
                camera,
                album,
                faceDownload,
                faceSuccess,
                faceFailed,
                isCameraActive:false,
                fileList:[],
                faceDetectionModelsLoaded:false,
                currentFile:null,
                previewImage:null,
            },
            editFace:{
                editFaceFrom:false,
                showClose:true,
                entranceKeyId:"",
                title:"",
                payload:"",
                locks:"",
                locksOptions:[
                    {
                        id:"1",
                        name:"Lock 1"
                    },
                    {
                        id:"2",
                        name:"Lock 2"
                    },
                ],
                countLimitDis:false,
                countLimit:1,
                Unlinmited:false,
                devList:[],
                entranceDeviceList:[],
                startTime:"",
                endTime:"",
                isFovever:false,
                fovever:false,
                userId:"",
                editBtnState:0,
            },
            delFace:{
                delFaceFrom:false,
                showClose:true,
                entranceKeyId:"",
                delBtnState:0,
            },
        }
    },
    mounted(){
       this.updateSiteUser.id = this.$route.params.id;
       this.updateSiteUser.userId = this.$route.params.userId;
    //    console.log("this.$route.params",this.$route.params,this.updateSiteUser.id);
       this.getSiteUserFaceDevicesList();
       //获取uesr Face 配置列表
       this.getSiteUserFaceList();
    },
    methods:{
        //10进制转为16进制
        decimalToHex(decimal) {
            return decimal.toString(16).toUpperCase();
        },
        //16进制转为10进制
        hexToDecimal(hexString) {
            return parseInt(hexString, 16);
        },
        //base64转为16进制字符串
        base64ToHex(base64String) {
            // 解码Base64字符串
            const byteArray = atob(base64String)
                .split('')
                .map(char => char.charCodeAt(0));
            
            // 转换为16进制字符串
            return byteArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
        },
        //字符串前面补0，直到满足长度要求
        padStringToLength(str, desiredLength) {
            return str.padStart(desiredLength, '0');
        },
        //字节数组转为16进制字符串  
        byteToHex(arr) {
            let hexStr = "";
            for (let i = 0; i < arr.length; i++) {
                let hex = arr[i].toString(16);
                if (hex.length === 1) {
                hex = "0" + hex;
                }
                hexStr += hex;
            }
            return hexStr;
        },
        //字节数组转为16进制字符串  
        createFileIv() {
            // 创建16字节数组，每个字节都是字符"0"的ASCII码(0x30)
            const byteArray = new Uint8Array(16).fill('0'.charCodeAt(0));
            // 转换为WordArray
            const wordArray = CryptoJS.lib.WordArray.create(byteArray);
            return wordArray;
        },
        //16进制转base64
        hexStringToBase64(hexString) {
            // 将16进制字符串转换为Uint8Array
            const byteArray = new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
            
            // 使用btoa将二进制数据转换为Base64字符串
            const base64String = btoa(String.fromCharCode(...byteArray));
            
            return base64String;
        },
        //HmacSHA1签名函数
        Hmacstr(sigstr, key) {
            let result = CryptoJS.HmacSHA1(sigstr, key);
            let sig = result.toString(CryptoJS.enc.Hex);
            return sig;
        },
        //查询住宅有权限设备列表
        getSiteUserFaceDevicesList(){
            let devicesInfoObj = {
                "rgn":this.selectCompany.companyRegion,
                "siteId":this.selectSite.id,
                "userHouseId":this.updateSiteUser.id,
                "pageSize":-1,
                "pageNum":1,
            }
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return
            }
            sitesUsersApi.getSiteUserDevicesList(devicesInfoObj).then(res => {
                if(res.code === 0){
                    this.addFace.devList = [];
                    this.editFace.devList = [];
                    if(res.data === null || res.data.list.length === 0){
                        this.addFace.devList = [];
                        this.editFace.devList = [];
                    }else{
                        res.data.list.forEach(item => {
                            if(item.accessStatus === 1 && this.$getBit(this.$base64ToByteArray(item.entranceAbility), 5) === 1){
                                item.isChecked = false;
                                this.addFace.devList.push(item);
                                this.editFace.devList.push(item);
                            }
                            
                        })
                    }
                }else{
                    this.addFace.devList = [];
                    this.editFace.devList = [];
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.addFace.devList = [];
                this.editFace.devList = [];
                // console.log(err);
            })
        },
        //查询用户Face Unlock列表
        getSiteUserFaceList(){
            let faceInfoObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let facePostObj = {
                "userHouseId":this.updateSiteUser.id,
                "userId":this.updateSiteUser.userId,
                "type":3,
            }
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return
            }
            sitesUsersApi.getSiteUserCardConfigList(faceInfoObj,facePostObj).then(res => {
                if(res.code === 0){
                    this.face.faceList = [];
                    if(res.data === null || res.data.length === 0){
                        this.face.faceList = [];
                        this.face.hasNoFace = true;
                    }else{
                        this.face.hasNoFace = false;
                        for(let i=0;i<res.data.length;i++){
                            this.face.faceList.push(res.data[i]);
                        }
                    }
                }else{
                    this.face.faceList = [];
                    this.face.hasNoFace = true;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.face.faceList = [];
                this.face.hasNoFace = true;
                console.log(err);
            })
        },
         //解密人脸
        //  decryptFaceUnlock(cardVal){
        //     //将tdk+userHouseId使用SHA256生成AES加密KEY
        //     let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
        //     //把获取到的16进制的字符串转为base64
        //     let base64Str = this.hexStringToBase64(cardVal);
        //     // console.log("cardVal",cardVal)
        //     // console.log("base64Str",base64Str)
        //     //解密之后密码
        //     let cardNumHex = decryptCBC(base64Str,payloadKey,CryptoJS.enc.Hex.parse(this.createFileIv(new Uint8Array(16))));
        //     // console.log("cardNumHex",cardNumHex)
        //     return cardNumHex
        // },
        //处理次数
        handCountLimit(count,usedCount){
            let countLimitStr = "";
            if(count === 0){
                countLimitStr = this.$t('Unlinmited');
            }else{
                countLimitStr = usedCount + "/" + count;
            }
            return countLimitStr
        },
        //处理有效期
        validityTime(start,end){
            let validityStr = "";
            if(start === 0 && end === 0){
                validityStr = this.$t('Forever');
            }else{
                validityStr = this.utctolocal(start) + " ~ " + this.utctolocal(end);
            }
            return validityStr
        },
         //panels 名称显示
         showPanelsName(panelList){
            let panelStr = "";
            if(this.addFace.devList.length != 0){
                this.addFace.devList.map(item =>{
                    panelList.map(item2 =>{
                        if(item.id === item2){
                            panelStr += item.deviceName +  "\u2003"
                        }
                    })
                })
            }
            return panelStr;
        },
         //处理设备应用状态函数
         handPanelApplyStatus(statu){
            let statuStr = "";
           switch (statu) {
            case 0:
                statuStr = this.$t('NotApplied');
                break;
            case 1:
                statuStr = this.$t('ApplicationComplete');
                break;
            case 2:
                statuStr = this.$t('DataValidationFailed');
                break;
            case 3:
                statuStr = this.$t('TypesNotSupported');
                break;
            case 4:
                statuStr = this.$t('DeviceLimitedInput');
                break;
            case 5:
                statuStr = this.$t('DeviceDataDuplication');
                break;
            default:
                statuStr = "";
           }
            return statuStr
        },
        addFaceSetting(){
            this.addFace.addFaceFrom = true;
            this.addFace.title = "";
            this.addFace.payload = "";
            this.addFace.locks = "";
            this.addFace.countLimit = "";
            this.addFace.countLimitDis = false;
            this.addFace.Unlinmited = false;
            this.addFace.startTime = "";
            this.addFace.endTime = "";
            this.addFace.isFovever = false;
            this.addFace.fovever = false;
            this.addFace.devList.map(item =>{
                item.isChecked = false;
            })
        },
        //添加Face 不限次数开关改变函数
        addFaceUnlinmitChage(item){
            if(item){
                this.addFace.countLimit = "";
                this.addFace.countLimitDis = true;
            }else{
                this.addFace.countLimitDis = false;
            }
        },
        //添加Face 永久有效开关改变函数
        addFaceForeverChage(item){
            if(item){
                this.addFace.startTime = "";
                this.addFace.endTime = "";
                this.addFace.isFovever = true;
            }else{
                this.addFace.isFovever = false;
            }
        },

        //添加人脸弹窗
        showFaceRecordBox(){
            this.loadFaceDetectionModels();
            this.addFaceRecord.addFaceRecordFrom = true;
            this.initCamera();
            this.addFaceRecord.showUploadType = 1;
            this.addFaceRecord.faceRecordfootBoxShow = 1;
        },
      
        //加载人脸模型
        async loadFaceDetectionModels() {
            try {
                // 加载人脸检测模型
                await faceapi.nets.tinyFaceDetector.loadFromUri(
                    '/faceapi/weights'
                );
                console.log('faceapi.nets loading completed');
                this.addFaceRecord.faceDetectionModelsLoaded = true;
            } catch (error) {
                console.error('Model loading failed:', error);
                this.$message.error(this.$t('FaceModelFailedLoad'));
            }
        },
        //初始化相机
        async initCamera() {
            try {
                // 请求摄像头权限
                this.videoStream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        width: { ideal: 500 },
                        height: { ideal: 500 },
                        facingMode: 'user' // 使用前置摄像头
                    },
                    audio: false
                });
                // console.log("videoStream",this.videoStream);
                this.addFaceRecord.isCameraActive = true;

                const videoElement = this.$refs.videoElement;
                // console.log("videoElement",videoElement);
                videoElement.srcObject = this.videoStream;
                
                this.$message.success(this.$t('CameraSuccessActivated'));
                
            } catch (error) {
                console.error('Unable Access Camera:', error.message);
                // this.hasCameraPermission = false;
                this.$message.error(this.$t('UnableAccessCamera'));
            }
        },
        //点击拍照
        takePhoto(){
            this.addFaceRecord.showUploadType = 1;
            this.addFaceRecord.isUploadPhoto = 1;
            this.captureImage();
        },
        //获取照片
        async captureImage() {
            if (!this.addFaceRecord.isCameraActive) {
                this.$message.warning(this.$t('PleaseTurnOnCamera'));
                return;
            }

            if (!this.addFaceRecord.faceDetectionModelsLoaded) {
                this.$message.warning(this.$t('FaceDetectionModelNotLoaded'));
                return;
            }

            try {
                // const videoElement = document.getElementById('videoElement');
                const videoElement = this.$refs.videoElement;
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                
                // 设置canvas尺寸与视频一致
                canvas.width = videoElement.videoWidth;
                canvas.height = videoElement.videoHeight;
                
                // 绘制当前视频帧到canvas
                context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
                //canvas.toDataURL(type, encoderOptions) type：指定图像的 MIME 类型，默认值为 image/png 可设为image/jpeg
                /**
                 * const dataURL = canvas.toDataURL(type, encoderOptions);
                 * type：指定图像的 MIME 类型，默认值为 image/png。常见的类型包括：
                 * image/png：PNG 格式，支持透明度。
                 * image/jpeg：JPEG 格式，不支持透明度，可以通过 encoderOptions 指定图像质量（范围为 0 到 1）。
                 * 
                 * encoderOptions：仅在 type 为 image/jpeg 或 image/webp 时使用，指定图像的质量
                 * 
                 */
                const canvasImg = canvas.toDataURL('image/jpeg', 1);
                // console.log("canvasImg",canvasImg);
                //canvas转base64位图片，进行人脸校验
                this.addFaceRecord.previewImage = canvasImg;
                this.addFaceRecord.showUploadType = 2;
                this.addFaceRecord.isUploadPhoto = 1;
                
                //在canvas中画图
                this.drawImageOnCanvas(videoElement);

                // this.addFaceRecord.previewImage = this.dataURLtoBlob(this.addFaceRecord.previewImage);
                // console.log('sssssss',this.dataURLtoBlob(this.addFaceRecord.previewImage));
                //校验人脸图片
                this.detectFaces();
                
            } catch (error) {
                console.error('Photo inspection failed:', error.message);
                this.$message.error(this.$t('PhotoInspectionFailed'));
            } finally {
                
            }
        },
        //Base64转二进制
        dataURLtoBlob(dataurl) { 
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });//返回blob对象
        },
        //上传人脸照片相关
        //限制图片类型
        checkFileType(file){
            const fileName = file.name;
            const fileType = fileName.substring(fileName.lastIndexOf('.'));
            if(fileType.toLocaleLowerCase() !== '.jpg'){
                this.$message.info(this.$t("UploadImagejpg"));
                // this.addNotice.isUpload = false;
                return false;
            }
            const fileSize = file.size / 1024 / 1024 <= 2;
            if (!fileSize) {
                this.$message.info(this.$t('UploadedImageLimit'));
                return false;
            }
            // this.addNotice.updateImg = true;
            return true;
        },
        //文件状态改变调用
        handleFileChange(file){
            if (!file) return;
            //清空文件列表，解决二次上传文件显示问题
            this.addFaceRecord.fileList = [];
            if(file.status  === 'ready'){
                this.addFaceRecord.currentFile = file.raw;
                this.addFaceRecord.showUploadType = 2;
                this.addFaceRecord.isUploadPhoto = 2;
                this.addFaceRecord.previewImage = URL.createObjectURL(file.raw);
                // this.$message.success('图片上传成功');

                // 加载图片
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        // 绘制图片
                        this.drawImageOnCanvas(img);
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(file.raw);
                
                this.detectFaces();
            }
            
        },

        /**
         * CanvasRenderingContext2D.drawImage() 在 HTML5 Canvas 上绘制图像的方法
         * drawImage(image, dx, dy, dWidth, dHeight);
         * 参数:
         * image：要绘制的图像，可以是 HTMLImageElement、HTMLCanvasElement 或 HTMLVideoElement。
         * dx：图像在 Canvas 上的水平位置
         * dy：图像在 Canvas 上的垂直位置。
         * dWidth：图像在 Canvas 上的宽度。
         * dHeight：图像在 Canvas 上的高度。
        */
        //在canvas上画图片
        drawImageOnCanvas(img) {
            this.$nextTick(function(){
                let showPhotoCanvas = this.$refs.showPhotoCanvas;
                let showPhotoCtx = showPhotoCanvas.getContext('2d');
                // 清除Canvas
                showPhotoCtx.clearRect(0, 0, 480, 480);
                // 计算图片原始宽高比
                const imgWidth = img.width | img.videoWidth;
                const imgHeight = img.height | img.videoHeight;
                const imgRatio = imgWidth / imgHeight;
                // 计算canvas宽高比
                const canvasRatio = showPhotoCanvas.width / showPhotoCanvas.height;

                let drawWidth, drawHeight, offsetX = 0, offsetY = 0;
                // 根据比例决定缩放方式
                if (imgRatio > canvasRatio) {
                    // 图片更宽，按宽度缩放，高度自适应
                    drawWidth = showPhotoCanvas.width;
                    drawHeight = showPhotoCanvas.width / imgRatio;
                    // 垂直居中
                    offsetY = (showPhotoCanvas.height - drawHeight) / 2;
                } else {
                    // 图片更高或比例相同，按高度缩放，宽度自适应
                    drawHeight = showPhotoCanvas.height;
                    drawWidth = showPhotoCanvas.height * imgRatio;
                    // 水平居中
                    offsetX = (showPhotoCanvas.width - drawWidth) / 2;
                }
                // 绘制图片
                showPhotoCtx.drawImage(
                    img,
                    offsetX, offsetY,  // 绘制位置
                    drawWidth, drawHeight  // 绘制尺寸
                );

                // showPhotoCtx.drawImage(img, 0, 0, 480, 480);

                this.canvasToBlob(showPhotoCanvas);
            })
        },
        //下载图片
        downloadCanvasWithQuality() {
            let canvas = this.$refs.showPhotoCanvas;
            canvas.toBlob(function(blob) {
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.download = new Date().getTime() + ".jpg";
                link.href = url;
                link.click();
                URL.revokeObjectURL(url);
            }, 'image/jpeg', 0.8);
        },
        //canvas图片转二进制
        async canvasToBlob(canvas){
            try{
                const blob = await new Promise((resolve, reject) => {
                    canvas.toBlob(
                        (resultBlob) => {
                            if (resultBlob) {
                                resolve(resultBlob);
                            } else {
                                reject(new Error('Blob转换失败'));
                            }
                        },
                        'image/jpeg',
                        0.8
                    );
                });
                // console.log('canvasToBlob',blob);
                //将 Blob 对象转换为 ArrayBuffer
                this.addFace.file = await blob.arrayBuffer();

                // console.log("this.addFace.file",this.addFace.file);

                 /**
                 * 1. 将Blob转换为ArrayBuffer以便加密
                 *  const arrayBuffer = await blob.arrayBuffer();
                 * 2. 定义密钥和IV（初始化向量）
                 *  在实际项目中，密钥应该通过安全的方式（如HTTPS下的认证后接口）从后端获取。
                 *  const secretKey = CryptoJS.enc.Utf8.parse('1234567812345678'); // 密钥必须是16/24/32字节
                 *  const iv = CryptoJS.enc.Utf8.parse('1234567812345678');        // IV必须是16字节
                 * 3. 将ArrayBuffer转换为CryptoJS可操作的WordArray
                 *  const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
                 * 4. 执行AES加密 (CBC模式, PKCS7填充)
                 *  const encryptedData = CryptoJS.AES.encrypt(wordArray, secretKey, {
                        iv: iv,
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7
                    });

                * 5. 将加密后的数据转换为Blob
                *  const encryptedBlob = new Blob([encryptedData.ciphertext], { type: 'application/octet-stream' });
                * 6. 创建FormData并上传加密后的Blob
                *  const formData = new FormData();
                    formData.append('file', encryptedBlob, 'encrypted_image.aes'); // 扩展名可自定义
                * 
                */

                //将tdk+userHouseId使用SHA256生成AES加密KEY
                let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
                // 将ArrayBuffer转换为CryptoJS可操作的WordArray: CryptoJS.lib.WordArray.create(arrayBuffer); 执行AES加密 (CBC模式, PKCS7填充)
                let encryObj = encryptCBCFile(CryptoJS.lib.WordArray.create(new Uint8Array(this.addFace.file)),payloadKey,this.createFileIv());
                
                // 将加密后的WordArray转换为ArrayBuffer
                let encryptedArrayBuffer = this.wordArrayToArrayBuffer(encryObj.ciphertext);
                this.addFace.encryptedBlob = null;
                // 将加密后的数据转换为Blob
                const encryptedBlob = new Blob([encryptedArrayBuffer], { type: 'application/octet-stream' });
                //先清空MD5(16进制)的值
                this.addFace.fileMD5Str = null;
                this.addFace.encryptedBlob = encryptedBlob;
                this.fileToMD5Hex(encryptedBlob);
            }catch(error){
                console.error('Blob转换失败:', error);
            } 
        },
        // 将CryptoJS WordArray转换为ArrayBuffer
        wordArrayToArrayBuffer(wordArray) {
            const words = wordArray.words;
            const length = wordArray.sigBytes;
            const arrayBuffer = new ArrayBuffer(length);
            const uint8Array = new Uint8Array(arrayBuffer);
            
            for (let i = 0; i < length; i++) {
                uint8Array[i] = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
            }
            
            return arrayBuffer;
        },
        //获取加密后的图片MD5 16进制 生成签名的时候使用
        fileToMD5Hex(file){
            const reader = new FileReader();
            const spark = new SparkMD5.ArrayBuffer();
            reader.onload = e => {
                spark.append(e.target.result)
                this.addFace.fileMD5Str = spark.end();
                // console.log("this.addFace.fileMD5Str",this.addFace.fileMD5Str);
            }
            reader.readAsArrayBuffer(file);
        },
        //校验人脸图片
        async detectFaces() {
            if(this.addFaceRecord.isUploadPhoto === 2){
                if (!this.addFaceRecord.currentFile || !this.addFaceRecord.previewImage) {
                    this.$message.warning(this.$t('PleaseTakePhotoOrUploadPicture'));
                    return;
                }
            }

            if (!this.addFaceRecord.faceDetectionModelsLoaded) {
                this.$message.error(this.$t("FaceDetectionModelNotLoaded"));
                return;
            }
            this.addFaceRecord.faceRecordfootBoxShow = 2;
            try {
                // 创建图片元素
                const img = new Image();
                img.src = this.addFaceRecord.previewImage;
                
                await new Promise((resolve) => {
                    img.onload = resolve;
                });
                // 进行人脸检测
                const detections = await faceapi
                    .detectAllFaces(img, new faceapi.TinyFaceDetectorOptions())
                    // .withFaceLandmarks()
                    // .withFaceDescriptors();
                // console.log('detections',detections);
                // 处理检测结果
                if(detections.length > 0){
                    this.addFaceRecord.faceRecordfootBoxShow = 3;
                }else{
                    this.addFaceRecord.faceRecordfootBoxShow = 4;
                }
            } catch (error) {
                console.error('Face detection failed:', error.message);
                this.$message.error(this.$t("FaceDetectionFailed"));
                this.addFaceRecord.faceRecordfootBoxShow = 4;
            } finally {
                // this.isProcessing = false;
            }
        },

        //人脸图片校验成功
        photoValiditedSuccess(){
            this.addFaceRecord.addFaceRecordFrom = false;
            this.addFaceRecord.showUploadType = 1;
            this.addFaceRecord.faceRecordfootBoxShow = 1;
            // this.addFace.file = this.addFaceRecord.currentFile;
        },
        //人脸图片校验失败，点击Retry
        photoValiditedRetry(){
            //清空已存的人脸文件(ArrayBuffer)
            this.addFace.file = null;
            this.addFaceRecord.showUploadType = 1;
            this.addFaceRecord.faceRecordfootBoxShow = 1;
        },
        //将数字转为62进制
        toBase62(num) {
            // 定义62进制字符集
            const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const radix = chars.length;
            
            // 处理大数字，确保输入为数字类型
            let number = typeof num === 'string' ? parseInt(num, 10) : num;
            
            if (number === 0) return '0';
            if (number < 0) {
                throw new Error('不支持负数转换');
            }
            
            let result = '';
            
            while (number > 0) {
                const remainder = number % radix;
                result = chars[remainder] + result;
                number = Math.floor(number / radix);
            }
            
            return result;
        },
        //人脸开锁图片名称(雪花算法)
        createFaceUnlockName(){
            let qrcodeStr = '';
            if(this.updateSiteUser.id){
                let snowflake = new SnowflakeId({
                    mid : this.updateSiteUser.id.slice(-6),
                });
                let getSnowId = snowflake.generate();
                qrcodeStr = this.toBase62(Number(getSnowId));
            }
            return qrcodeStr;
        },
        //添加FaceUnlock配置点击确定执行函数
        addFaceUnlock(){
            let checkCardName = this.$regularCheckLimit(this.addFace.title,1,64,'NameCannotEmpty');
            if(!checkCardName){
                return false
            }
            if(!this.addFace.file){
                this.$message.info(this.$t('PleaseTakePhotoOrUploadPicture'));
                return false
            }
            if(this.addFace.locks.length == 0){
                this.$message.info(this.$t('UnlockOptionEmpty'));
                return false
            }
            let finCountLimit = 0;
            if(this.addFace.Unlinmited){
                finCountLimit = 0;
            }else{
                // if(this.addFace.countLimit === ""){
                //     this.$message.info(this.$t('LimitedEmpty'));
                //     return false
                // }else{
                //     if(Number(this.addFace.countLimit) > 999){
                //         this.$message.info(this.$t('LimitUnlockNum').replace('100','999'));
                //         return false
                //     }
                // }
                let countLimitReg = /^([1-9][0-9]{0,2})$|^[1-9]$/;
                if(!countLimitReg.test(this.addFace.countLimit)){
                    this.$message.info(this.$t('LimitUnlockNumLimit'));
                    return false
                }
                finCountLimit = this.addFace.countLimit;
            }
            let finStartTime = 0;
            let finEndTime = 0;
            if(this.addFace.fovever){
                finStartTime = 0;
                finEndTime = 0;
            }else{
                if(this.addFace.startTime == null){
                    this.addFace.startTime = "";
                }
                if(this.addFace.endTime == null){
                    this.addFace.endTime = "";
                }
                if(this.addFace.startTime === ""){
                    this.$message.info(this.$t('StartTimeEmptye'));
                    return false
                }
                if(this.addFace.endTime === ""){
                    this.$message.info(this.$t('EndTimeEmptye'));
                    return false
                }
                if(this.addFace.startTime != "" && this.addFace.endTime != ""){
                    if(this.addFace.startTime >= this.addFace.endTime){
                        this.$message.info(this.$t('StartTimeLaterEndTime'));
                        return false
                    }
                }
                finStartTime = this.addFace.startTime;
                finEndTime = this.addFace.endTime;

            }
            let finDevArr = [];
            this.addFace.devList.map(item =>{
                if(item.isChecked){
                    finDevArr.push(item.id)
                }
            })
            if(finDevArr.length === 0){
                this.$message.info(this.$t('PleaseSelectPanels'));
                return false
                
            }

            // //将tdk+userHouseId使用SHA256生成AES加密KEY
            // let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            // // 将ArrayBuffer转换为CryptoJS可操作的WordArray: CryptoJS.lib.WordArray.create(arrayBuffer); 执行AES加密 (CBC模式, PKCS7填充)
            // let encryObj = encryptCBCFile(CryptoJS.lib.WordArray.create(new Uint8Array(this.addFace.file)),payloadKey,this.createFileIv());
            // // 将加密后的数据转换为Blob
            // const encryptedBlob = new Blob([encryObj.ciphertext], { type: 'application/octet-stream' });
            let nowTimeTamp = new Date().getTime();
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let addUserFaceUnlockObj = {
                "type": 3,
                "userHouseId":this.updateSiteUser.id,
                "checkKeyId": nowTimeTamp, 
                "title": this.addFace.title,
                "file": this.addFace.fileMD5Str,
                "locks": this.addFace.locks.join(","),
                "countLimit": finCountLimit,
                "startTime": finStartTime,
                "endTime": finEndTime,
                "entranceDeviceIds": finDevArr,
                "timestamp": nowTimeTamp,
                "createTime": nowTimeTamp,
            };
            // console.log("addUserFaceUnlockObj",addUserFaceUnlockObj);
            // return false
            const sortedData = Object.keys(addUserFaceUnlockObj)
                    .sort()
                    .map(key => `${key}=${addUserFaceUnlockObj[key]}`)
                    .join("&");
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userHouseId', this.updateSiteUser.id);
            formData.append('userId', this.updateSiteUser.userId);
            formData.append('type', 3);
            formData.append('checkKeyId', nowTimeTamp);
            formData.append('title', this.addFace.title);
            formData.append('file', this.addFace.encryptedBlob,this.createFaceUnlockName() + '.jpg');
            formData.append('locks', this.addFace.locks.join(","));
            formData.append('countLimit', finCountLimit);
            formData.append('startTime', finStartTime);
            formData.append('endTime', finEndTime);
            formData.append('entranceDeviceIds', finDevArr);
            formData.append('timestamp', nowTimeTamp);
            formData.append('createTime', nowTimeTamp);
            formData.append('sign', this.Hmacstr(sortedData,this.updateSiteUser.id));
            // return false
            this.addFace.addBtnState = 1;
            sitesUsersApi.addSiteUserCardConfig(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('AddSuccessful'));
                    this.addFace.addBtnState = 0;
                    //获取uesr Face 配置列表
                    this.getSiteUserFaceList();
                    this.addFace.addFaceFrom = false;
                }else{
                    this.addFace.addBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.addFace.addBtnState = 0;
            })
        },
        //人脸开锁列表点击编辑
        editFaceSetting(item){
            this.editFace.editFaceFrom = true;
            let faceInfoObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let facePostObj = {
                "userHouseId":this.updateSiteUser.id,
                "entranceKeyId":item.entranceKeyId,
                "userId":item.userId,
            }
            sitesUsersApi.getSiteUserCardDetail(faceInfoObj,facePostObj).then(res => {
                if(res.code === 0){
                   this.editFace.title = res.data.title;
                   //将tdk+userHouseId使用SHA256生成AES加密KEY
                   let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
                   //把获取到的16进制的字符串转为base64
                //    let base64Str = this.hexStringToBase64(res.data.payload);
                   //解密之后得密码
                //    let cardNumHex = decryptCBC(base64Str,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
                //    this.editFace.payload = cardNumHex;
                   this.editFace.userId = res.data.userId;
                   this.editFace.entranceKeyId = res.data.entranceKeyId;
                   this.editFace.locks = (res.data.locks).split(",");
                   if(res.data.countLimit === 0){
                       this.editFace.countLimit = "";
                       this.editFace.countLimitDis = true;
                       this.editFace.Unlinmited = true;
                   }else{
                       this.editFace.countLimitDis = false;
                       this.editFace.Unlinmited = false;
                       this.editFace.countLimit = res.data.countLimit;
                   }
                   if(res.data.startTime === 0 && res.data.endTime === 0){
                       this.editFace.startTime = "";
                       this.editFace.endTime = "";
                       this.editFace.isFovever = true;
                       this.editFace.fovever = true;
                   }else{
                       this.editFace.startTime = res.data.startTime;
                       this.editFace.endTime = res.data.endTime;
                       this.editFace.isFovever = false;
                       this.editFace.fovever = false;
                   }
                   this.editFace.entranceDeviceList = res.data.entranceDeviceList;
                   this.editFace.devList.map(item=>{
                        item.isChecked = false;
                        if (item.hasOwnProperty('applyStatus')) {
                            delete item.applyStatus
                        }
                    })
                    // console.log("this.editFace.entranceDeviceList",this.editFace.entranceDeviceList)
                    this.editFace.devList.map(item=>{
                        this.editFace.entranceDeviceList.map(item2=>{
                            if(item.id === item2.entranceDeviceId){
                                item.isChecked = true;
                                item.applyStatus = item2.applyStatus;
                            }
                        })
                    })
                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
            })
            
        },
        //编辑Face 不限次数开关改变函数
        editFaceUnlinmitChage(item){
            if(item){
                this.editFace.countLimit = "";
                this.editFace.countLimitDis = true;
            }else{
                this.editFace.countLimitDis = false;
            }
        },
        //编辑Face 永久有效开关改变函数
        editFaceForeverChage(item){
            if(item){
                this.editFace.startTime = "";
                this.editFace.endTime = "";
                this.editFace.isFovever = true;
            }else{
                this.editFace.isFovever = false;
            }
        },

        //编辑Face确认
        editFaceUnlock(){
            let checkCardName = this.$regularCheckLimit(this.editFace.title,1,64,'NameCannotEmpty');
            if(!checkCardName){
                return false
            }
            // if((this.editFace.payload.toString()).trim() === ""){
            //     this.$message.info(this.$t('UnlockPasswordEmpty'));
            //     return false
            // }
            if(this.editFace.locks.length == 0){
                this.$message.info(this.$t('UnlockOptionEmpty'));
                return false
            }
            let finCountLimit = 0;
            if(this.editFace.Unlinmited){
                finCountLimit = 0;
            }else{
                // if(this.editFace.countLimit === ""){
                //     this.$message.info(this.$t('LimitedEmpty'));
                //     return false
                // }else{
                //     if(Number(this.editFace.countLimit) > 999){
                //         this.$message.info(this.$t('LimitUnlockNum').replace('100','999'));
                //         return false
                //     }
                // }
                let countLimitReg = /^([1-9][0-9]{0,2})$|^[1-9]$/;
                if(!countLimitReg.test(this.editFace.countLimit)){
                    this.$message.info(this.$t('LimitUnlockNumLimit'));
                    return false
                }
                finCountLimit = this.editFace.countLimit;
            }
            let finStartTime = 0;
            let finEndTime = 0;
            if(this.editFace.fovever){
                finStartTime = 0;
                finEndTime = 0;
            }else{
                if(this.editFace.startTime == null){
                    this.editFace.startTime = "";
                }
                if(this.editFace.endTime == null){
                    this.editFace.endTime = "";
                }
                if(this.editFace.startTime === ""){
                    this.$message.info(this.$t('StartTimeEmptye'));
                    return false
                }
                if(this.editFace.endTime === ""){
                    this.$message.info(this.$t('EndTimeEmptye'));
                    return false
                }
                if(this.editFace.startTime != "" && this.editFace.endTime != ""){
                    if(this.editFace.startTime >= this.editFace.endTime){
                        this.$message.info(this.$t('StartTimeLaterEndTime'));
                        return false
                    }
                }
                finStartTime = this.editFace.startTime;
                finEndTime = this.editFace.endTime;

            }
            let finDevArr = [];
            this.editFace.devList.map(item =>{
                if(item.isChecked){
                    finDevArr.push(item.id)
                }
            })
            if(finDevArr.length === 0){
                this.$message.info(this.$t('PleaseSelectPanels'));
                return false
                
            }
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            // 先转16进制 在加密 
            // let finCardNum = this.decimalToHex(Number(this.editFace.payload));
            // let encryStr = encryptCBC(this.editFace.payload,payloadKey,CryptoJS.enc.Hex.parse(this.createFileIv(new Uint8Array(16))));
            let nowTimeTamp = new Date().getTime();
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let editUserFaceObj = {
                "type": 3,
                "userHouseId":this.updateSiteUser.id,
                "entranceKeyId":this.editFace.entranceKeyId,
                // "checkKeyId": new Date().getTime(), 
                "title": this.editFace.title,
                // "payload": this.base64ToHex(encryStr),
                // "cardType": 24,
                "locks": this.editFace.locks.join(","),
                "countLimit": finCountLimit,
                "startTime": finStartTime,
                "endTime": finEndTime,
                "entranceDeviceIds": finDevArr,
                "timestamp": nowTimeTamp,
            };
            const sortedData = Object.keys(editUserFaceObj)
                    .sort()
                    .map(key => `${key}=${editUserFaceObj[key]}`)
                    .join("&");
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userHouseId', this.updateSiteUser.id);
            formData.append('userId', this.updateSiteUser.userId);
            formData.append('entranceKeyId', this.editFace.entranceKeyId);
            formData.append('type', 3);
            formData.append('checkKeyId', nowTimeTamp);
            formData.append('title', this.editFace.title);
            // formData.append('payload', this.base64ToHex(encryStr));
            // formData.append('cardType', 24);
            formData.append('locks', this.editFace.locks.join(","));
            formData.append('countLimit', finCountLimit);
            formData.append('startTime', finStartTime);
            formData.append('endTime', finEndTime);
            formData.append('entranceDeviceIds', finDevArr);
            formData.append('timestamp', nowTimeTamp);
            formData.append('sign', this.Hmacstr(sortedData,this.updateSiteUser.id));
            this.editFace.editBtnState = 1;
            sitesUsersApi.updateSiteUserCardConfig(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('UpdateSuccessfully'));
                    this.editFace.editBtnState = 0;
                    //获取uesr Face 配置列表
                    this.getSiteUserFaceList();
                    this.editFace.editFaceFrom = false;
                }else{
                    this.editFace.editBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.editFace.editBtnState = 0;
            })
        },
        //删除Face弹窗
        openDelFaceFrom(item){
            this.delFace.delFaceFrom = true;
            this.delFace.entranceKeyId = item.entranceKeyId;
        },
        //删除Face 确认
        delFaceSetting(){
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            const delSiteUserFaceObj = {}
            delSiteUserFaceObj.entranceKeyId = [];
            delSiteUserFaceObj.entranceKeyId.push(this.delFace.entranceKeyId);
            delSiteUserFaceObj.userHouseId = this.updateSiteUser.id;
            delSiteUserFaceObj.userId = this.updateSiteUser.userId;
            this.delFace.delBtnState = 1;
            sitesUsersApi.delSiteUserCard(rgnObj,delSiteUserFaceObj).then(res => {
                if(res.code === 0){
                    this.delFace.delBtnState = 0;
                    this.$message.success(this.$t('DeleteSuccessfully'));
                    this.delFace.delFaceFrom = false;
                    //获取uesr Face 配置列表
                    this.getSiteUserFaceList();
                }else{
                    this.delFace.delBtnState = 0;
                    this.$handerrcode(res.code);
                }
                
            }).catch((err) => {
                this.delFace.delBtnState = 0;
                console.log('err', err);
            })
            
        },
    },
    computed:{
        ...mapState(["selectCompany","selectSite"])
    },
    watch:{
      
    }
}
</script>

<style scoped>
.addsiteUersBox{
    display: flex;
}
.addSiteUserLeft{
    width: 50%;
    padding-right: 1vw;
}
.NameBox{
    display: flex;
    justify-content: space-between;
}

.addSiteUserRight{
    width: 50%;
    font-size: 18px !important;
    margin-left: 2vw;
}
.addSiteUserRight p {
    font-size: 16px;
    color: #CFCFCF;
}
.addSiteUserRight p span{
    color: #6498b5;
}
::v-deep .addSiteUserRight .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 100%;
    border: none;
    background: #EFEFEF;
}
.licenseBox{
    background: #EFEFEF;
    margin-top: 1vw;
    padding: 1vw 1vw;
    height: 105px;
    overflow-y: auto;
    border-radius: 10px;
}
.LimitContent{
    border-top:1px solid #ddd;
    /* border-radius: 8px; */
    padding-bottom: 15px;
}
.LimitBox{
    display: flex;
    justify-content: space-between;
    height: 45px;
}
::v-deep .LimitBox label{
    margin-top: 10px !important;
}
.FoveverBox{
    display: flex;
    justify-content: space-between;
    height: 45px;
}
.cardText{
    width:48%;
    text-align: right;
    padding-right: 20px; 
    margin-top: 20px;color: #333;
}
::v-deep .el-form-item__label{
    text-align: left;
}
.addCard .el-button--primary {
    margin-left: 60px !important;
    color: #fff;
    background-color: #6498b5;
    border-color: #6498b5;
}

::v-deep .el-dialog {
    border-radius: 15px !important;
    width: 1200px;
}

::v-deep .el-dialog__header {
    background-color: #6498b5 !important;
    border-radius: 15px 15px 0 0 !important;
    text-align: center;
}
::v-deep .el-dialog__title {
    color: #fff !important;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 24px;
    line-height: 0.6;
}
::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: #fff !important;
}
.faceRecordfootBox{
    margin-top: 20px;
    display: flex;
    justify-content: space-evenly;
}
.faceRecordfootBox img{
    width: 35px;
    cursor: pointer;
}
</style>